/** @format */

export enum AuthTypeEnum {
	// authType有四个值 native:原始登录 cas:cas认证登录 oauth2 ldap
	NATIVE = 'native',
	CAS = 'cas',
	OAUTH2 = 'oauth2',
	LDAP = 'ldap',
}
